import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { RequestModel } from 'src/app/shopping-cart/request-model.model';

@Component({
  selector: 'app-add-request-button',
  templateUrl: './add-request-button.component.html',
  styleUrls: ['./add-request-button.component.scss']
})
export class AddRequestButtonComponent implements OnInit {
  request: RequestModel;
  @Input() public group: boolean;
  @Input() public validated = false;
  @Input() public reqType: string;
  @Output() submit = new EventEmitter();
  @Output() close = new EventEmitter<boolean>();
  reqAdd = false;

  constructor() {}

  ngOnInit() {}

  closeParent() {
    this.close.emit(false);
  }

  addRequest(): void {
    this.submit.emit();
    this.reqAdd = true;
  }
}
